<template>
<span
        class="switch"
        @click="toggle_switch()"
        @keydown.enter="toggle_switch()"
        @keydown.space.prevent="toggle_switch()"
        :aria-checked="modelValue?'true':'false'"
        :class="classObject"
        role="checkbox"
        tabindex="0"
        ref="switchSpan"
>
    <small></small>
    <input type="checkbox" :name="name" style="display:none"/>
    <span class="switch-text"></span>
</span>
</template>
<script>
    export default {
        name: 'VueSwitch',
        emits: ['change', 'update:modelValue'],
        props: {
            name: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false
            },
            small: {
                type: Boolean,
                required: false,
                default: false
            },
            modelValue: Boolean
        },
        data() {
            return {};
        },
        computed: {
            classObject: function () {
                return {
                    checked: this.modelValue,
                    disabled: this.disabled,
                    'switch--small': this.small
                };
            }
        },
        methods: {
            toggle_switch() {
                if (this.disabled) {
                    return;
                }
                this.$emit('update:modelValue', !this.modelValue);
                this.$emit('change');
            },
            focus() {
                this.$refs.switchSpan?.focus();
            },
        },
    };
</script>
<style lang="scss" scoped>
  $switch-width: 52px;
  // wider width for larger switch text
  $switch-wide-width: 80px;
  $switch-height: 30px;
  $switch-knob-offset: 22px;
  // wider switch text moves the knob further to the right
  $switch-wide-knob-offset: 52px;
  $switch-font-size: 13px;
  // the `small` prop halves every dimension
  $switch-small-scale: 0.8;

  // all the size-dependent rules, so a scaled-down switch keeps its proportions
  @mixin switch-size($scale: 1) {
    width: $switch-width * $scale;
    height: $switch-height * $scale;

    &.wide {
      width: $switch-wide-width * $scale;
    }

    > small {
      width: $switch-height * $scale;
      height: $switch-height * $scale;
    }

    &.checked > small {
      left: $switch-knob-offset * $scale;
    }

    &.wide.checked > small {
      left: $switch-wide-knob-offset * $scale;
    }

    .switch-text {
      font-size: $switch-font-size * $scale;
    }
  }

  .switch {
    background: #bebebe;
    border: 1px solid #dfdfdf;
    position: relative;
    display: inline-block;
    box-sizing: content-box;
    overflow: visible;
    padding: 0;
    margin: 0;
    border-radius: 20px;
    cursor: pointer;
    box-shadow: rgb(223, 223, 223) 0 0 0 0 inset;
    transition: 0.3s ease-out all;
    -webkit-transition: 0.3s ease-out all;
    top: -1px;

    @include switch-size;

    &.switch--small {
      @include switch-size($switch-small-scale);
    }

    > small {
      background: #fff;
      border-radius: 100%;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.3s ease-out all;
      -webkit-transition: 0.3s ease-out all;
    }

    &.checked {
      background: rgb(100, 189, 99);
      border-color: rgb(100, 189, 99);

      .off {
        display: none;
      }

      .on {
        display: block;
      }
    }

    .switch-text {
      font-family: Arial, Helvetica, sans-serif;
    }

    .off {
      display: block;
      position: absolute;
      right: 10%;
      top: 25%;
      z-index: 0;
      color: #A9A9A9;
    }

    .on {
      display: none;
      z-index: 0;
      color: #fff;
      position: absolute;
      top: 25%;
      left: 9%;
    }

    &.disabled {
      opacity: .50;
      cursor: not-allowed;
    }
  }
</style>
